
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/team/[slug]",
      function () {
        return require("private-next-pages/[lang]/team/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/team/[slug]"])
      });
    }
  